export default __webpack_public_path__ + "static/media/36I-103555_-17656_0.25fd3584.jpg";